import React, { createContext, useContext, useState, useCallback } from 'react';

const CartContext = createContext();

// Product variants for Loren Aura Makeup Brush
export const PRODUCTS = {
  'set': {
    id: 'loren-aura-set',
    name: 'Loren Aura Brush Set',
    nameBn: 'লরেন অরা ব্রাশ সেট',
    size: '13 Pieces',
    price: 250,
    originalPrice: 350,
    freeDelivery: false,
    popular: true,
    image: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=400&h=400&fit=crop'
  }
};

const PRODUCT = PRODUCTS['set']; // Default product for backward compatibility

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState('set');
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback((message) => {
    setNotification(message);
    setTimeout(() => setNotification(null), 3000);
  }, []);

  const addToCart = useCallback((quantity = 1) => {
    setCartItems(prev => {
      const existingItem = prev.find(item => item.id === PRODUCT.id);
      if (existingItem) {
        return prev.map(item =>
          item.id === PRODUCT.id
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      }
      return [...prev, { ...PRODUCT, quantity }];
    });
    showNotification(quantity);
  }, [showNotification]);

  const removeFromCart = useCallback((productId) => {
    setCartItems(prev => prev.filter(item => item.id !== productId));
  }, []);

  const updateQuantity = useCallback((productId, quantity) => {
    if (quantity <= 0) {
      removeFromCart(productId);
      return;
    }
    setCartItems(prev =>
      prev.map(item =>
        item.id === productId ? { ...item, quantity } : item
      )
    );
  }, [removeFromCart]);

  const clearCart = useCallback(() => {
    setCartItems([]);
  }, []);

  const cartCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);
  const cartTotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);

  const value = {
    cartItems,
    cartCount,
    cartTotal,
    isCartOpen,
    setIsCartOpen,
    isCheckoutOpen,
    setIsCheckoutOpen,
    selectedVariant,
    setSelectedVariant,
    addToCart,
    removeFromCart,
    updateQuantity,
    clearCart,
    notification,
    PRODUCT,
    PRODUCTS
  };

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

